/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class used to represent a transaction
 */
export type TransactionBaseDTO = {
    /**
     * Creation date
     */
    createdAt?: string;
    /**
     * Currency used in the transaction
     */
    currency?: string;
    /**
     * Account balance after transaction being completed
     */
    currentAccountBalance?: number;
    /**
     * Description associated with transaction
     */
    description?: string;
    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    direction?: string;
    /**
     * The operation Id associated with the transaction
     */
    operationId?: string;
    /**
     * Indicates if the transaction is a partial transaction and the type of partial transaction
     */
    partialTransactionType?: string;
    /**
     * Indicates which payment method was used in the transaction.
     */
    paymentMethod?: TransactionBaseDTO.paymentMethod;
    /**
     * Status of the operation this transaction belongs to; absent when there is none
     */
    status?: TransactionBaseDTO.status;
    /**
     * TerminalID associated with this transaction if payment is made by POS
     */
    terminalId?: string;
    /**
     * Amount involved in the transaction
     */
    totalAmount?: number;
    /**
     * Indicates the transaction id saved in external service
     */
    transactionId?: string;
    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    transactionType?: TransactionBaseDTO.transactionType;
};

export namespace TransactionBaseDTO {

    /**
     * Indicates which payment method was used in the transaction.
     */
    export enum paymentMethod {
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        MOMO = 'MOMO',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        PAYMENT_LINK_CARD = 'PAYMENT_LINK_CARD',
        PAYMENT_LINK_USSD = 'PAYMENT_LINK_USSD',
        PAYMENT_LINK_QR_CODE = 'PAYMENT_LINK_QR_CODE',
        PAYMENT_LINK_PAY_WITH_TRANSFER = 'PAYMENT_LINK_PAY_WITH_TRANSFER',
        POS = 'POS',
        CASH = 'CASH',
        CARD = 'CARD',
        POS_ORDER = 'POS_ORDER',
        STAMP_DUTY = 'STAMP_DUTY',
        TRANSACTION_CHARGE = 'TRANSACTION_CHARGE',
        MANUAL_CREDIT = 'MANUAL_CREDIT',
        MANUAL_DEBIT = 'MANUAL_DEBIT',
        OUTLET_WITHDRAWAL = 'OUTLET_WITHDRAWAL',
        OUTLET_AUTO_SWEEP = 'OUTLET_AUTO_SWEEP',
        PAYMENT_LINK = 'PAYMENT_LINK',
        STATIC_ACCOUNT = 'STATIC_ACCOUNT',
    }

    /**
     * Status of the operation this transaction belongs to; absent when there is none
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        EXPIRED = 'EXPIRED',
        PENDING = 'PENDING',
        PENDING_CREDIT = 'PENDING_CREDIT',
        DECLINED = 'DECLINED',
        FAILED = 'FAILED',
        REVERSED = 'REVERSED',
    }

    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    export enum transactionType {
        IN = 'IN',
        OUT = 'OUT',
    }


}

